import React from "react";
import { LIST_OFFTIME_REPORT_TABLE_HEAD } from "../../variables/constants";
import { Button, Card, Typography } from "@material-tailwind/react";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function OfftimeReportTable(props) {
  const handleDownload = () => {
    const data = props.offtimeList.map((offtime) => {
      return [
        offtime.off_datetime
          ? moment(offtime.off_datetime).format("DD/MM/YYYY HH:mm")
          : "-",
        offtime.on_datetime
          ? moment(offtime.on_datetime).format("DD/MM/YYYY HH:mm")
          : "-",
      ];
    });

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet([
      LIST_OFFTIME_REPORT_TABLE_HEAD,
      ...data,
    ]);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Offtime Report");

    // Convert workbook to binary string
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Save the file
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      "offtime_report.xlsx"
    );
  };

  return (
    <div>
      <div className="mt-5 md:mt-8">
        <div className="flex justify-between items-center mb-4">
          <div>
            <p className="text-2xl font-bold text-black pb-2">
              Off-time Report
            </p>
            <p className="text-black font-semibold text-2xl">
              Branch: {props.offtimeList?.[0]?.branch_name}
            </p>
          </div>

          {props.offtimeList?.length > 0 && (
            <Button
              onClick={handleDownload}
              className="font-poppins font-medium tracking-wider bg-[#03438D]"
            >
              Download
            </Button>
          )}
        </div>

        {props.offtimeList?.length > 0 ? (
          <Card
            className="h-full w-full rounded-none overflow-x-scroll md:overflow-x-hidden"
            style={{
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)",
            }}
          >
            <table className="w-full min-w-max table-auto text-center">
              <thead>
                <tr>
                  {LIST_OFFTIME_REPORT_TABLE_HEAD.map((head) => (
                    <th
                      key={head}
                      className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                    >
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-poppins text-white font-semibold uppercase"
                      >
                        {head}
                      </Typography>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.offtimeList.map((offtime, index) => {
                  return (
                    <tr key={index}>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {offtime.off_datetime
                            ? moment(offtime.off_datetime).format(
                                "DD/MM/YYYY HH:mm"
                              )
                            : "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {offtime.on_datetime
                            ? moment(offtime.on_datetime).format(
                                "DD/MM/YYYY HH:mm"
                              )
                            : "-"}
                        </Typography>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>
        ) : (
          <div className="text-center h-[50vh] flex flex-col justify-center items-center">
            <p className="font-semibold text-xl sm:text-3xl">
              Oops! No Data Found...
            </p>
            <p className="text-sm mt-2 ">
              Looks like we couldn't find any data.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default OfftimeReportTable;
